import { ASSETS_RESOURCE_TYPES, AssetsUrlService } from './assets-url-service';

class ImagesUrlService extends AssetsUrlService {
    constructor(domain, base) {
        super(domain, base, ASSETS_RESOURCE_TYPES.IMAGE);
    }
}

export default ImagesUrlService;
